import * as ko from 'knockout';
import entityBase from 'entityBase';

export class model extends entityBase {
    internal_descriptn: KnockoutObservable<string>;
    model_id          : KnockoutObservable<string>;
    model_category    : KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.internal_descriptn = ko.observable(item.internal_descriptn).extend({ maxLength: 256 });
        this.model_id           = ko.observable(item.model_id).extend({ maxLength: 128 });
        this.model_category     = ko.observable(item.model_category ? item.model_category : "");
    }
}


